interface IProps {
  name: string;
  className: string;
  url: string;
  show_img: string;
  name_tag: string;
}

const domain = process.env.GIFT_NET_URL;

const MeetingComponent = (props: IProps): string => {
  return `
            <a class='$${props.className} d-block  card-link' data-value='${props.name_tag}' href="${domain}${props.url}">
                  <img src="${domain}${props.show_img}" />
             </a>
           
  `;
};
export default MeetingComponent;
